import { getGAClientId, getGASessionId } from '@shared/libs/analytics';

import { AnalyticsApi } from '@entities/analytics';

export async function trackBid({ auctionId, transactionHash }: { auctionId: string; transactionHash: string }) {
  const sessionId = getGASessionId();
  const clientId = getGAClientId();

  if (!sessionId || !clientId) {
    console.warn('GA session or client ID not found, cannot track bid.');
    return;
  }

  const analyticsApi = new AnalyticsApi(fetch);

  try {
    await analyticsApi.trackBid({
      sessionId,
      clientId,
      auctionId,
      transactionHash,
    });
  } catch (error) {
    console.error('Failed to track bid:', error);
  }
}
